import { useRef } from "react";

// Stand-ins for callbacks that are re-created on every render: each keeps
// one identity for the component's lifetime and calls the latest version.
// Passed to a React.memo child, they let it skip the parent's re-renders
// (e.g. one per keystroke in the message box) without ever calling an
// outdated handler.
export default function useStableCallbacks(callbacks) {
  const latest = useRef(callbacks);
  latest.current = callbacks;
  const stable = useRef({});
  Object.keys(callbacks).forEach((name) => {
    if (!stable.current[name]) {
      stable.current[name] = (...args) => latest.current[name]?.(...args);
    }
  });
  return stable.current;
}
